'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002ejs$002e$002dMap$0024 from "./scala.scalajs.js.-Map$.js";
var $p;
function $f_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString__valueFromString__sjs_js_Map($thiz) {
  var $x_2 = $j_scala$002escalajs$002ejs$002e$002dMap$0024.$m_sjs_js_Map$();
  var this$5 = $thiz.NX();
  var f = ((v) => new $j_java$002elang$002e$002dObject.$c_T2($thiz.CK(v), v));
  if ((this$5 === $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
    var $x_1 = $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  } else {
    var x0 = this$5.E();
    var h = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
    var t = h;
    var rest = this$5.H();
    while ((rest !== $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
      var x0$1 = rest.E();
      var nx = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0$1), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
      t.ao = nx;
      t = nx;
      rest = rest.H();
    }
    var $x_1 = h;
  }
  return $x_2.Sr($x_1);
}
export { $f_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString__valueFromString__sjs_js_Map as $f_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString__valueFromString__sjs_js_Map };
function $f_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString__fromString__T__s_Option($thiz, s) {
  var map = $thiz.QS();
  return ((!(!map.has(s))) ? new $j_java$002elang$002e$002dObject.$c_s_Some(map.get(s)) : $j_java$002elang$002e$002dObject.$m_s_None$());
}
export { $f_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString__fromString__T__s_Option as $f_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString__fromString__T__s_Option };
